// extracted by mini-css-extract-plugin
export default {"btn":"WhatsAppButton_btn__hFxMT","icon":"WhatsAppButton_icon__MfpsC","pulse":"WhatsAppButton_pulse__dIfCr"};